// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accept-cookies_wrapper__uuDrb","container":"accept-cookies_container__z8_sH","button":"accept-cookies_button__ymrlv"};